import { G as GraphGradientMode } from '../../../../../common.gen-CZ1M9G8L.js';

const pluginVersion = "12.1.0-pre";
const defaultOptions = {
  bucketCount: 30,
  bucketOffset: 0
};
const defaultFieldConfig = {
  fillOpacity: 80,
  gradientMode: GraphGradientMode.None,
  lineWidth: 1
};

export { defaultFieldConfig, defaultOptions, pluginVersion };
